import PlanGroupIds from '../constants/planGroupIds';
import PlanIds from '../constants/planIds';

export const planNumberEnum = {
  STANDARD: PlanIds.STANDARDV21STANDARD,
  PREMIUM: PlanIds.STANDARDV21PREMIUM,
};

export const getPremiumId = (planGroupId) => {
  if (planGroupId === PlanGroupIds.LARGELISTV23_PLANGROUP_ID) return PlanIds.LARGELISTPREMIUMV23;

  if (planGroupId === PlanGroupIds.AUSTRALIA_V1) return PlanIds.AUSTRALIA_V1_PREMIUM;

  if (planGroupId === PlanGroupIds.GREAT_BRITAIN_V1) return PlanIds.GREATBRITAIN_V1_PREMIUM;

  if (planGroupId === PlanGroupIds.GREAT_BRITAIN_LEAD_MAGNET) return PlanIds.GREATBRITAIN_LEAD_MAGNET_PREMIUM;

  if (planGroupId === PlanGroupIds.NEW_ZEALAND_V1) return PlanIds.NEWZEALAND_V1_PREMIUM;

  return PlanIds.STANDARDV21PREMIUM;
};

/** Lite/Bronze plan id for SMS "starting at" pricing (tier-1 list price, not premium-included tiers). */
export const getBronzeId = (planGroupId) => {
  if (planGroupId === PlanGroupIds.LARGELISTV23_PLANGROUP_ID) return PlanIds.LARGELISTLITEV23;

  if (planGroupId === PlanGroupIds.AUSTRALIA_V1) return PlanIds.AUSTRALIA_V1_LITE;

  if (planGroupId === PlanGroupIds.GREAT_BRITAIN_V1) return PlanIds.GREATBRITAIN_V1_LITE;

  if (planGroupId === PlanGroupIds.GREAT_BRITAIN_LEAD_MAGNET) return PlanIds.GREATBRITAIN_LEAD_MAGNET_LITE;

  if (planGroupId === PlanGroupIds.NEW_ZEALAND_V1) return PlanIds.NEWZEALAND_V1_LITE;

  return PlanIds.STANDARDV21LITE;
};

export const getCurrencySymbol = (currency) => {
  // eslint-disable-line
  if (currency) {
    return (0)
      .toLocaleString(navigator.language, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, '')
      .trim();
  }

  return '';
};

export const formatCurrency = (currency, amount, minimumFractionDigits = 2) => {
  return new Intl.NumberFormat(navigator.language, { style: 'currency', currency, minimumFractionDigits }).format(
    amount
  );
};

export const formatPlainCurrency = (amount, minimumFractionDigits) => {
  return new Intl.NumberFormat(navigator.language, {
    style: 'decimal',
    minimumFractionDigits: minimumFractionDigits == null ? 2 : minimumFractionDigits,
  }).format(amount);
};
